import { createStore } from "redux";
import { TABLET_SCREEN_SIZE, MOBILE_SCREEN_SIZE } from "./constants/constants";

// Check screen size for initial state
const isBelowTablet =
  typeof window !== "undefined" && window.innerWidth <= TABLET_SCREEN_SIZE;

// Sidebar visibility is set to true if screen is above tablet size
const initialState = {
  sidebarShow: isBelowTablet ? false : true,
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      return { ...state, ...rest };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
